module.exports = __webpack_public_path__ + "img/grin.e7cc5cbf.svg";